import { render, staticRenderFns } from "./myWords.vue?vue&type=template&id=250cc5b0&scoped=true"
import script from "./myWords.vue?vue&type=script&lang=js"
export * from "./myWords.vue?vue&type=script&lang=js"
import style0 from "./myWords.vue?vue&type=style&index=0&id=250cc5b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250cc5b0",
  null
  
)

export default component.exports